import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.collections');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { INITIAL_COLLECTIONS, INITIAL_TAGS } from './static-cache';

@Component({
    selector: 'wiz-page-collections',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.collections/view.scss */
:host {
  display: block;
  height: 100%;
}

.tag-item:hover .tag-delete-btn {
  opacity: 1;
}

.advanced-search-backdrop {
  background: rgba(28, 25, 23, 0.56);
  backdrop-filter: blur(3px);
}

.advanced-search-modal {
  background: #fafaf9;
  border: 1px solid rgba(68, 64, 60, 0.18);
  box-shadow: 0 24px 80px rgba(28, 25, 23, 0.28);
}

.advanced-search-header {
  background: #292524;
  border-bottom-color: #44403c;
}

.advanced-search-header h2 {
  color: #fafaf9;
}

.advanced-search-close {
  color: #d6d3d1;
}

.advanced-search-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.advanced-search-tabs {
  background: #f5f5f4;
  border-bottom-color: #e7e5e4;
}

.advanced-search-body {
  background: #fafaf9;
}

.advanced-search-modal section,
.advanced-search-modal .rounded-xl.border {
  background: #ffffff;
  border-color: #e7e5e4;
  border-radius: 8px;
}

.advanced-search-modal section {
  padding: 16px;
}

.advanced-search-modal input,
.advanced-search-modal select {
  border-color: #d6d3d1;
  background: #ffffff;
}

.advanced-search-modal input:focus,
.advanced-search-modal select:focus {
  border-color: #78716c !important;
  box-shadow: 0 0 0 2px rgba(120, 113, 108, 0.24) !important;
}

.advanced-search-modal .border-blue-500,
.advanced-search-modal .border-blue-600,
.advanced-search-modal [class*=border-blue-100] {
  border-color: #57534e !important;
}

.advanced-search-modal .text-blue-700,
.advanced-search-modal [class*=text-blue-700] {
  color: #1c1917 !important;
}

.advanced-search-modal .bg-blue-600 {
  background: #1c1917 !important;
}

.advanced-search-modal .bg-blue-600:hover {
  background: #000000 !important;
}

.advanced-search-modal [class*=bg-blue-50] {
  background: #f5f5f4 !important;
}

.advanced-search-modal [class*=bg-blue-100] {
  background: #e7e5e4 !important;
}

.advanced-search-footer {
  background: #f5f5f4;
  border-top-color: #e7e5e4;
}

:host-context(.dark) .advanced-search-backdrop {
  background: rgba(12, 10, 9, 0.72);
}

:host-context(.dark) .advanced-search-modal {
  background: #1c1917;
  border-color: #44403c;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.56);
}

:host-context(.dark) .advanced-search-header {
  background: #0c0a09;
  border-bottom-color: #44403c;
}

:host-context(.dark) .advanced-search-tabs,
:host-context(.dark) .advanced-search-footer,
:host-context(.dark) .advanced-search-body {
  background: #1c1917;
  border-color: #44403c;
}

:host-context(.dark) .advanced-search-modal section,
:host-context(.dark) .advanced-search-modal .rounded-xl.border {
  background: #292524;
  border-color: #44403c;
}

:host-context(.dark) .advanced-search-modal input,
:host-context(.dark) .advanced-search-modal select {
  background: #1c1917;
  border-color: #57534e;
}

:host-context(.dark) .advanced-search-modal [class*="dark:bg-blue-900"],
:host-context(.dark) .advanced-search-modal [class*=bg-blue-50] {
  background: rgba(68, 64, 60, 0.58) !important;
}

:host-context(.dark) .advanced-search-modal [class*="dark:text-blue-300"],
:host-context(.dark) .advanced-search-modal [class*=text-blue-700] {
  color: #f5f5f4 !important;
}

:host-context(.dark) .advanced-search-modal [class*="dark:border-blue-900"],
:host-context(.dark) .advanced-search-modal .border-blue-500,
:host-context(.dark) .advanced-search-modal .border-blue-600 {
  border-color: #78716c !important;
}`],
})
export class PageCollectionsComponent implements OnInit {
    public collections: any[] = INITIAL_COLLECTIONS;
    public documents: any[] = [];
    public documentSearchResults: any[] = [];
    public documentSearching: boolean = false;
    public documentSearchDone: boolean = false;
    public tags: any[] = [];
    public selectedTags: string[] = [];
    public loading: boolean = false;
    public showCreateModal: boolean = false;
    public showAdvancedSearchModal: boolean = false;
    public newCollection: any = { title: '', description: '', tags: [] };
    public allTags: any[] = INITIAL_TAGS;
    public newTagName: string = '';
    public openMenuId: string = '';
    public newTagColor: string = '#6366f1';
    public loadingProgress: number = 100;
    public loadingStage: string = '캐시 표시 완료';

    public COLOR_PALETTE: string[] = [
        '#6366f1', '#8b5cf6', '#ec4899', '#ef4444', '#f97316',
        '#eab308', '#22c55e', '#14b8a6', '#06b6d4', '#3b82f6',
        '#78716c', '#475569'
    ];

    public searchText: string = '';
    public sortBy: string = 'created';
    public viewMode: string = 'list';
    public activeListTab: string = 'collections';
    public showMobileFilter: boolean = false;
    public selectedCategory: string = 'all';
    public savedFilters: any[] = [];
    public newFilterName: string = '';
    public createStep: number = 0;
    public documentSearchPage: number = 1;
    public documentSearchPageSize: number = 10;
    private documentSearchSeq: number = 0;
    public advancedSearchTab: string = 'type';
    public advancedSearch: any = this.defaultAdvancedSearch();

    public categoryFilters: any[] = [
        { key: 'all', label: '전체', short: '전체', keywords: [] },
        { key: 'dokdo', label: '독도·동해', short: '독도', keywords: ['독도', '동해', '울릉도', '해양', '영토'] },
        { key: 'japan', label: '한일 역사현안', short: '한일', keywords: ['한일', '일본', '위안부', '강제동원', '교과서', '야스쿠니'] },
        { key: 'china', label: '한중 역사현안', short: '한중', keywords: ['한중', '중국', '동북공정', '고구려', '발해'] },
        { key: 'archive', label: '고지도·사료', short: '사료', keywords: ['고지도', '지도', '사료', '문헌', '원문', '아카이브'] },
        { key: 'policy', label: '정책·대응자료', short: '정책', keywords: ['정책', '대응', '현안', '보고서', '리포트'] },
        { key: 'education', label: '교육·홍보자료', short: '교육', keywords: ['교육', '홍보', '전시', '콘텐츠', '해설'] },
        { key: 'publication', label: '재단 간행도서', short: '간행', keywords: ['간행물', '간행도서', '재단', '발간', '논문', '학술', '자료집', '총서'] }
    ];

    public createSteps: any[] = [
        { key: 'basic', label: '기본정보' },
        { key: 'source', label: '수집출처' },
        { key: 'subject', label: '분류/주제' },
        { key: 'access', label: '공개/권한' },
        { key: 'confirm', label: '확인' }
    ];
    public collectionTemplates: any[] = [
        { key: 'china', label: '한중관계사', collectionType: '재단 간행도서', issueTopics: ['한중관계'], tags: ['한중관계사'] },
        { key: 'japan', label: '한일관계사', collectionType: '재단 간행도서', issueTopics: ['한일관계'], tags: ['한일관계사'] },
        { key: 'dokdo', label: '독도·동해', collectionType: '재단 간행도서', issueTopics: ['독도', '동해'], tags: ['독도·동해'] },
        { key: 'translation', label: '번역·외국어', collectionType: '사료·문헌', languages: ['영어', '일본어', '중국어'], tags: ['번역·외국어'] },
        { key: 'etc', label: '기타', collectionType: '기타', tags: ['기타'] }
    ];
    public advancedTabs: any[] = [
        { key: 'type', label: '간단검색' },
        { key: 'author', label: '전문검색' },
        { key: 'subject', label: '주제·전거' }
    ];

    public materialTypeOptions: string[] = [
        '전체', '사료/문헌', '고지도/지도', '재단간행도서', '보고서/정책자료',
        '교육·홍보자료', '기사/해설', '멀티미디어', '웹/SNS', '기타'
    ];
    public multimediaTypeOptions: string[] = [
        '지도자료', '이미지/사진', '컴퓨터파일', '영상자료', '마이크로자료',
        '복합기록물', 'SNS', '온라인게임', 'VR·AR·MR'
    ];
    public languageOptions: string[] = ['전체', '한국어', '영어', '일본어', '중국어', '러시아어', '기타'];
    public frequencyOptions: string[] = ['전체', '연간', '반년간', '계간', '월간', '주간', '일간', '기타'];
    public editionTypeOptions: string[] = ['적용안함', '원본', '복제', '영인', '번역', '해제'];
    public availabilityOptions: string[] = ['적용안함', '외부 링크', '로컬 원문', '활용 가능'];
    public searchScopeOptions: any[] = [
        { value: 'all', label: '전체' },
        { value: 'title', label: '기사제목/자료명' },
        { value: 'body', label: '본문내용' },
        { value: 'creator', label: '저·편·발신·수신자' },
        { value: 'identifier', label: '관리번호' }
    ];
    public authorRoleOptions: string[] = ['전체', '저자', '편자', '발신자', '수신자', '발행기관', '관련기관'];
    public issueTopicOptions: string[] = ['독도', '동해', '일본군 위안부', '강제동원', '한일관계', '한중관계', '고구려·발해', '동북공정', '동아시아 교류'];
    public periodOptions: string[] = ['상고·고대', '고려', '조선', '개항기', '일제강점기', '현대'];
    public regionOptions: string[] = ['한국', '일본', '중국', '러시아', '만주·연해주', '동아시아', '기타'];
    public sourceGroupOptions: string[] = ['동북아역사넷', '역사이슈', '사료라이브러리', '독도아카이브', '동아시아 고지도', '재단 간행도서', '교육·홍보 콘텐츠'];
    public kdcCategories: string[] = ['총류', '철학', '종교', '사회과학', '자연과학', '기술과학', '예술', '언어', '문학', '역사'];
    public kdcSubcategories: string[] = ['도서학,서지학', '문헌정보학', '백과사전', '강연집, 수필집, 연설문집', '일반 연속간행물', '신문, 저널리즘', '일반전집, 총서', '향토자료'];
    public kdcTopics: string[] = ['저작', '사본, 판본, 제본', '출판 및 판매', '개인서지 및 목록', '국가별 서지 및 목록', '주제별 서지 및 목록', '특수서지 및 목록', '일반서지 및 목록'];
    public ddcCategories: string[] = ['Computer science, information & general works', 'Philosophy & psychology', 'Religion', 'Social sciences', 'Language', 'Science', 'Technology', 'Arts & recreation', 'Literature', 'History & geography'];
    public ddcSubcategories: string[] = ['Bibliography', 'Library & information sciences', 'Encyclopedias', 'Serial publications', 'General organizations', 'News media, journalism & publishing', 'General collections', 'Manuscripts & rare books'];
    public collectionTypeOptions: string[] = ['재단 간행도서', '사료·문헌', '고지도·지도', '보고서·정책자료', '교육·홍보자료', '기사·해설', '멀티미디어', '웹·SNS 수집', '기타'];
    public sourceChannelOptions: string[] = ['동북아역사재단 자료센터', '동북아역사넷', '독도아카이브', '사료라이브러리', '동아시아 고지도', '외부기관 수집', '오프라인 소장자료', '기타'];
    public registrationPolicyOptions: string[] = ['서지 먼저 만들고 원문은 별도 입수', 'PDF 업로드 후 원문 분석', '외부 링크 보관', '외부 서지 반입 후 보강', '수기 입력 후 분석 대기'];
    public accessLevelOptions: string[] = ['내부 열람', '연구자 공개', '기관 내부 공유', '전체 공개', '제한 공개'];
    public createLanguageOptions: string[] = ['한국어', '일본어', '중국어', '영어', '러시아어', '기타'];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.service.render();
        this.loadStaticListCache()
            .then(async () => await this.service.render())
            .catch(() => false)
            .then(() => this.refreshListFromApi(true))
            .catch((e: any) => console.error(e));

        this.loadSavedFilters()
            .then(async () => await this.service.render())
            .catch((e: any) => console.error(e));
    }

    public async load() {
        this.loading = true;
        this.setLoadingProgress(5, '정적 캐시 요청 중');
        await this.service.render();

        const cacheLoaded = await this.loadStaticListCache();
        if (cacheLoaded) await this.renderLoadingProgress(72, '정적 캐시 적용 완료');
        await this.renderLoadingProgress(82, '자료함 API 동기화 중');
        await this.refreshListFromApi(false);
        await this.renderLoadingProgress(100, '표시 준비 완료');
        this.loading = false;
        await this.service.render();
    }

    private applyListPayload(data: any) {
        this.collections = data?.collections || [];
        this.documents = data?.documents || [];
        this.allTags = data?.tags || [];
    }

    private async loadStaticListCache(): Promise<boolean> {
        try {
            const response = await fetch('/assets/cache/collections_list.json', { cache: 'force-cache' });
            if (!response.ok) return false;
            this.applyListPayload(await response.json());
            return true;
        } catch (e) {
            return false;
        }
    }

    private async refreshListFromApi(background: boolean) {
        try {
            const { code, data } = await wiz.call("list");
            if (code === 200) {
                this.applyListPayload(data);
                if (background) await this.service.render();
            }
        } catch (e) {
            console.error(e);
        }
    }

    private setLoadingProgress(progress: number, stage: string) {
        this.loadingProgress = progress;
        this.loadingStage = stage;
    }

    private async renderLoadingProgress(progress: number, stage: string) {
        this.setLoadingProgress(progress, stage);
        await this.service.render();
    }

    public async loadSavedFilters() {
        const { code, data } = await wiz.call("saved_filters", { scope: "collections" });
        if (code === 200) this.savedFilters = data.filters || [];
    }

    public async toggleTag(tag: string) {
        const idx = this.selectedTags.indexOf(tag);
        if (idx >= 0) {
            this.selectedTags.splice(idx, 1);
        } else {
            this.selectedTags.push(tag);
        }
        this.documentSearchPage = 1;
        await this.onSearch();
    }

    public async clearSelectedTags() {
        this.selectedTags = [];
        this.documentSearchPage = 1;
        await this.onSearch();
    }

    public isTagSelected(tag: string) {
        return this.selectedTags.indexOf(tag) >= 0;
    }

    public async setCategory(key: string) {
        this.selectedCategory = key;
        this.documentSearchPage = 1;
        await this.onSearch();
    }

    public async resetFilters() {
        this.selectedCategory = 'all';
        this.selectedTags = [];
        this.searchText = '';
        this.advancedSearch = this.defaultAdvancedSearch();
        this.advancedSearchTab = 'type';
        this.documentSearchResults = [];
        this.documentSearching = false;
        this.documentSearchDone = false;
        this.documentSearchPage = 1;
        this.documentSearchSeq++;
        await this.service.render();
    }

    public async setActiveListTab(tab: string) {
        this.activeListTab = tab;
        if (tab === 'documents') await this.onSearch();
        await this.service.render();
    }

    public currentFilterPayload(): any {
        return {
            searchText: this.searchText,
            selectedCategory: this.selectedCategory,
            selectedTags: this.selectedTags,
            advancedSearchTab: this.advancedSearchTab,
            advancedSearch: this.advancedSearch,
            activeListTab: this.activeListTab,
            sortBy: this.sortBy
        };
    }

    public async saveCurrentFilter() {
        const name = this.newFilterName.trim();
        if (!name) {
            await this.service.alert.show({ title: '알림', message: '저장할 필터 이름을 입력해주세요.' });
            return;
        }
        const { code } = await wiz.call("save_filter", {
            name,
            scope: "collections",
            payload: JSON.stringify(this.currentFilterPayload())
        });
        if (code === 200) {
            this.newFilterName = '';
            await this.loadSavedFilters();
            await this.service.render();
        }
    }

    public async applySavedFilter(filter: any) {
        const payload = filter?.payload || {};
        this.searchText = payload.searchText || '';
        this.selectedCategory = payload.selectedCategory || 'all';
        this.selectedTags = payload.selectedTags || [];
        this.advancedSearchTab = payload.advancedSearchTab || 'type';
        this.advancedSearch = payload.advancedSearch || this.defaultAdvancedSearch();
        this.activeListTab = payload.activeListTab || 'collections';
        this.sortBy = payload.sortBy || 'created';
        await this.onSearch();
    }

    public async deleteSavedFilter(filter: any, event: Event) {
        event.stopPropagation();
        if (!filter?.id) return;
        const { code } = await wiz.call("delete_filter", { id: filter.id });
        if (code === 200) await this.loadSavedFilters();
        await this.service.render();
    }

    public async toggleMenu(id: string, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        this.openMenuId = this.openMenuId === id ? '' : id;
        await this.service.render();
    }

    public async closeMenu() {
        if (this.openMenuId) {
            this.openMenuId = '';
            await this.service.render();
        }
    }

    public get filteredCollections() {
        let result = this.collections;

        if (this.selectedCategory !== 'all') {
            result = result.filter((col: any) => this.categoryMatches(col, this.selectedCategory));
        }

        if (this.selectedTags.length > 0) {
            result = result.filter((col: any) => {
                const colTags = col.tags || [];
                return this.selectedTags.some((t: string) => colTags.indexOf(t) >= 0);
            });
        }

        if (this.searchText.trim()) {
            const q = this.searchText.trim().toLowerCase();
            result = result.filter((col: any) => {
                const tagText = (col.tags || []).join(' ');
                const category = this.categoryFor(col).label;
                return [
                    col.title || '',
                    col.description || '',
                    tagText,
                    category,
                    this.catalogNo(col),
                    this.statusLabel(col),
                    this.recordType(col)
                ].join(' ').toLowerCase().includes(q);
            });
        }

        result = [...result].sort((a: any, b: any) => {
            if (this.sortBy === 'title') {
                return (a.title || '').localeCompare(b.title || '');
            }
            if (this.sortBy === 'doc_count') {
                return (b.doc_count || 0) - (a.doc_count || 0);
            }
            if (this.sortBy === 'status') {
                return this.completionPercent(b) - this.completionPercent(a);
            }
            return (b.created || '').localeCompare(a.created || '');
        });

        return result;
    }

    public get hasSearchText(): boolean {
        return this.searchText.trim().length > 0;
    }

    public get hasDocumentSearchFilter(): boolean {
        return this.selectedCategory !== 'all' || this.selectedTags.length > 0 || this.hasAdvancedSearchCriteria;
    }

    public get hasDocumentSearchCriteria(): boolean {
        return this.hasSearchText || this.hasDocumentSearchFilter;
    }

    public get filteredDocumentResults() {
        if (!this.hasDocumentSearchCriteria) return [];

        const q = this.searchText.trim().toLowerCase();
        const source = this.documentSearchDone ? this.documentSearchResults : this.documents;
        let result = source.filter((doc: any) => {
            const collection = this.collectionForDocument(doc);

            if (this.selectedCategory !== 'all' && !this.categoryMatches(collection, this.selectedCategory)) {
                return false;
            }

            if (this.selectedTags.length > 0) {
                const tags = doc.collection_tags || [];
                if (!this.selectedTags.some((t: string) => tags.indexOf(t) >= 0)) return false;
            }

            const searchText = [
                doc.filename || '',
                this.documentTitle(doc),
                this.documentCatalogNo(doc),
                doc.collection_title || '',
                (doc.collection_tags || []).join(' '),
                doc.hflib_title || '',
                doc.hflib_author || '',
                doc.hflib_publication || '',
                doc.hflib_isbn || '',
                doc.hflib_volume || '',
                doc.source_board || '',
                this.documentStatusLabel(doc.status),
                this.documentFormat(doc),
                String(doc.page_count || '')
            ].join(' ').toLowerCase();

            if (!q) return true;
            return this.documentRelevanceScore(doc) > 0 || searchText.includes(q);
        });

        return [...result].sort((a: any, b: any) => {
            const scoreDiff = this.documentRelevanceScore(b) - this.documentRelevanceScore(a);
            if (scoreDiff !== 0) return scoreDiff;
            return (b.created || '').localeCompare(a.created || '');
        });
    }

    public get documentSearchTotalPages(): number {
        return Math.max(1, Math.ceil(this.filteredDocumentResults.length / this.documentSearchPageSize));
    }

    public get currentDocumentSearchPage(): number {
        return Math.min(Math.max(this.documentSearchPage, 1), this.documentSearchTotalPages);
    }

    public get documentSearchPageStart(): number {
        if (this.filteredDocumentResults.length === 0) return 0;
        return (this.currentDocumentSearchPage - 1) * this.documentSearchPageSize;
    }

    public get documentSearchPageEnd(): number {
        return Math.min(this.documentSearchPageStart + this.documentSearchPageSize, this.filteredDocumentResults.length);
    }

    public get paginatedDocumentResults(): any[] {
        return this.filteredDocumentResults.slice(this.documentSearchPageStart, this.documentSearchPageEnd);
    }

    public get visibleDocumentSearchPages(): number[] {
        const total = this.documentSearchTotalPages;
        const current = this.currentDocumentSearchPage;
        const pages: number[] = [];
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public get totalDocuments(): number {
        return this.collections.reduce((sum: number, col: any) => sum + (col.doc_count || 0), 0);
    }

    public get totalCompleted(): number {
        return this.totalAvailable;
    }

    public get totalAvailable(): number {
        return this.collections.reduce((sum: number, col: any) => sum + this.availableCount(col), 0);
    }

    public get totalStorageSize(): number {
        return this.collections.reduce((sum: number, col: any) => sum + (col.total_size || 0), 0);
    }

    public get totalCompletionPercent(): number {
        if (this.totalDocuments === 0) return 0;
        return Math.round((this.totalAvailable / this.totalDocuments) * 100);
    }

    public async onSearch() {
        const keyword = this.searchText.trim();
        this.documentSearchSeq++;
        const seq = this.documentSearchSeq;
        this.documentSearchPage = 1;

        if (!keyword && !this.hasDocumentSearchFilter) {
            this.documentSearchResults = [];
            this.documentSearching = false;
            this.documentSearchDone = false;
            await this.service.render();
            return;
        }

        this.documentSearching = true;
        this.documentSearchDone = false;
        await this.service.render();

        const { code, data } = await wiz.call("search_documents", {
            keyword,
            category: this.selectedCategory,
            tags: JSON.stringify(this.selectedTags),
            advanced: JSON.stringify(this.advancedSearchPayload())
        });
        if (seq !== this.documentSearchSeq) return;

        this.documentSearchResults = code === 200 ? (data.documents || []) : [];
        this.documentSearching = false;
        this.documentSearchDone = true;
        await this.service.render();
    }

    public async setDocumentSearchPage(page: number) {
        this.documentSearchPage = Math.min(Math.max(page, 1), this.documentSearchTotalPages);
        await this.service.render();
    }

    public async setSort(sort: string) {
        this.sortBy = sort;
        await this.service.render();
    }

    public async setView(mode: string) {
        this.viewMode = mode;
        await this.service.render();
    }

    public completionPercent(col: any): number {
        const total = col.doc_count || 0;
        if (total === 0) return 0;
        return Math.round((this.availableCount(col) / total) * 100);
    }

    public availableCount(col: any): number {
        return col?.available_count ?? col?.completed_count ?? 0;
    }

    public collectionStorageSummary(col: any): string {
        const local = col?.local_count || 0;
        const external = col?.external_count || 0;
        if (local || external) return `로컬 ${local} · 링크 ${external}`;
        return this.formatSize(col?.total_size || 0);
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
        return (bytes / 1073741824).toFixed(1) + ' GB';
    }

    public getTagColor(tagName: string): string {
        const tag = this.allTags.find((t: any) => t.name === tagName);
        return tag?.color || '#78716c';
    }

    public defaultAdvancedSearch(): any {
        return {
            searchScope: 'all',
            detailKeyword: '',
            materialTypes: ['전체'],
            multimediaTypes: [],
            sourceUrl: '',
            title: '',
            author: '',
            publisher: '',
            keyword: '',
            yearFrom: '',
            yearTo: '',
            standardType: 'ISBN',
            standardNo: '',
            classificationScheme: 'KDC',
            classificationNo: '',
            callLocation: '',
            callClass: '',
            callBook: '',
            callVolume: '',
            university: '',
            government: '',
            bodyLanguage: '전체',
            originalLanguage: '전체',
            frequency: '전체',
            editionType: '적용안함',
            edition: '적용안함',
            availability: '적용안함',
            authorMode: 'person',
            authorRole: '전체',
            authorName: '',
            subjectScheme: 'kdc',
            kdcCategory: '',
            kdcSubcategory: '',
            kdcTopic: '',
            ddcCategory: '',
            ddcSubcategory: '',
            subjectKeyword: '',
            issueTopics: [],
            periods: [],
            regions: [],
            sourceGroups: []
        };
    }

    public get hasAdvancedSearchCriteria(): boolean {
        return this.advancedSearchCriteriaLabels.length > 0;
    }

    public get advancedSearchCriteriaLabels(): string[] {
        const labels: string[] = [];
        const add = (label: string, value: any) => {
            const text = String(value || '').trim();
            if (text && text !== '전체' && text !== '적용안함') labels.push(`${label} ${text}`);
        };

        if (this.advancedSearchTab === 'type') {
            const scope = this.searchScopeOptions.find((option: any) => option.value === this.advancedSearch.searchScope);
            add(scope?.label || '상세검색', this.advancedSearch.detailKeyword);
            const materialTypes = (this.advancedSearch.materialTypes || []).filter((item: string) => item && item !== '전체');
            if (materialTypes.length > 0) labels.push(`유형 ${materialTypes.join(', ')}`);
            const multimediaTypes = (this.advancedSearch.multimediaTypes || []).filter((item: string) => item);
            if (multimediaTypes.length > 0) labels.push(`멀티미디어 ${multimediaTypes.join(', ')}`);
            add('링크', this.advancedSearch.sourceUrl);
            add('기사제목/자료명', this.advancedSearch.title);
            add('본문내용', this.advancedSearch.keyword);
            add('저·편·발신·수신자', this.advancedSearch.author);
            add('출처/발행기관', this.advancedSearch.publisher);
            if (this.advancedSearch.yearFrom || this.advancedSearch.yearTo) {
                labels.push(`작성/발행일 ${this.advancedSearch.yearFrom || ''}-${this.advancedSearch.yearTo || ''}`);
            }
            add('자료이용', this.advancedSearch.availability);
        } else if (this.advancedSearchTab === 'author') {
            add(this.advancedSearch.authorMode === 'organization' ? '기관명' : '인명', this.advancedSearch.authorName);
            if (String(this.advancedSearch.authorName || '').trim()) add('역할', this.advancedSearch.authorRole);
        } else if (this.advancedSearchTab === 'subject') {
            add('주제어', this.advancedSearch.subjectKeyword);
            const issueTopics = (this.advancedSearch.issueTopics || []).filter((item: string) => item);
            if (issueTopics.length > 0) labels.push(`역사현안 ${issueTopics.join(', ')}`);
            const periods = (this.advancedSearch.periods || []).filter((item: string) => item);
            if (periods.length > 0) labels.push(`시대 ${periods.join(', ')}`);
            const regions = (this.advancedSearch.regions || []).filter((item: string) => item);
            if (regions.length > 0) labels.push(`지역 ${regions.join(', ')}`);
            const sourceGroups = (this.advancedSearch.sourceGroups || []).filter((item: string) => item);
            if (sourceGroups.length > 0) labels.push(`자료군 ${sourceGroups.join(', ')}`);
            add('언어', this.advancedSearch.bodyLanguage);
            add('자료이용', this.advancedSearch.availability);
        }

        return labels;
    }

    public get advancedSearchAppliedSummary(): string {
        const labels = this.advancedSearchCriteriaLabels;
        if (labels.length <= 2) return labels.join(' · ');
        return `${labels.slice(0, 2).join(' · ')} 외 ${labels.length - 2}개`;
    }

    public advancedSearchPayload(): any {
        const payload: any = { tab: this.advancedSearchTab };
        const add = (key: string, value: any, defaults: string[] = ['', '전체', '적용안함']) => {
            if (Array.isArray(value)) {
                const values = value.filter((item: string) => item && defaults.indexOf(item) < 0);
                if (values.length > 0) payload[key] = values;
                return;
            }
            const text = String(value || '').trim();
            if (text && defaults.indexOf(text) < 0) payload[key] = text;
        };

        if (this.advancedSearchTab === 'type') {
            if (String(this.advancedSearch.detailKeyword || '').trim()) add('searchScope', this.advancedSearch.searchScope, ['', 'all']);
            add('detailKeyword', this.advancedSearch.detailKeyword);
            add('materialTypes', this.advancedSearch.materialTypes);
            add('multimediaTypes', this.advancedSearch.multimediaTypes);
            add('sourceUrl', this.advancedSearch.sourceUrl);
            add('title', this.advancedSearch.title);
            add('author', this.advancedSearch.author);
            add('publisher', this.advancedSearch.publisher);
            add('keyword', this.advancedSearch.keyword);
            add('yearFrom', this.advancedSearch.yearFrom);
            add('yearTo', this.advancedSearch.yearTo);
            add('availability', this.advancedSearch.availability);
        } else if (this.advancedSearchTab === 'author') {
            add('authorMode', this.advancedSearch.authorMode, ['', 'person']);
            if (String(this.advancedSearch.authorName || '').trim()) add('authorRole', this.advancedSearch.authorRole);
            add('authorName', this.advancedSearch.authorName);
        } else if (this.advancedSearchTab === 'subject') {
            add('subjectKeyword', this.advancedSearch.subjectKeyword);
            add('issueTopics', this.advancedSearch.issueTopics);
            add('periods', this.advancedSearch.periods);
            add('regions', this.advancedSearch.regions);
            add('sourceGroups', this.advancedSearch.sourceGroups);
            add('bodyLanguage', this.advancedSearch.bodyLanguage);
            add('availability', this.advancedSearch.availability);
        }

        return payload;
    }

    public async openAdvancedSearchModal() {
        this.showAdvancedSearchModal = true;
        await this.service.render();
    }

    public async closeAdvancedSearchModal() {
        this.showAdvancedSearchModal = false;
        await this.service.render();
    }

    public async setAdvancedSearchTab(tab: string) {
        this.advancedSearchTab = tab;
        await this.service.render();
    }

    public async toggleMaterialType(type: string) {
        if (type === '전체') {
            this.advancedSearch.materialTypes = ['전체'];
            this.advancedSearch.multimediaTypes = [];
            this.advancedSearch.sourceUrl = '';
            await this.service.render();
            return;
        }
        this.advancedSearch.materialTypes = [type];
        if (type !== '멀티미디어') {
            this.advancedSearch.multimediaTypes = [];
        }
        if (type !== '웹/SNS') {
            this.advancedSearch.sourceUrl = '';
        }
        await this.service.render();
    }

    public isMaterialTypeSelected(type: string): boolean {
        return (this.advancedSearch.materialTypes || []).indexOf(type) >= 0;
    }

    public async toggleMultimediaType(type: string) {
        let selected = this.advancedSearch.multimediaTypes || [];
        const idx = selected.indexOf(type);
        if (idx >= 0) {
            selected.splice(idx, 1);
        } else {
            selected.push(type);
        }
        this.advancedSearch.multimediaTypes = selected;
        await this.service.render();
    }

    public isMultimediaTypeSelected(type: string): boolean {
        return (this.advancedSearch.multimediaTypes || []).indexOf(type) >= 0;
    }

    public async toggleAdvancedListOption(field: string, value: string) {
        let selected = this.advancedSearch[field] || [];
        const idx = selected.indexOf(value);
        if (idx >= 0) {
            selected.splice(idx, 1);
        } else {
            selected.push(value);
        }
        this.advancedSearch[field] = selected;
        await this.service.render();
    }

    public isAdvancedListOptionSelected(field: string, value: string): boolean {
        return (this.advancedSearch[field] || []).indexOf(value) >= 0;
    }

    public async setAdvancedAuthorMode(mode: string) {
        this.advancedSearch.authorMode = mode;
        await this.service.render();
    }

    public async setSubjectScheme(scheme: string) {
        this.advancedSearch.subjectScheme = scheme;
        await this.service.render();
    }

    public async applyAdvancedSearch() {
        this.showAdvancedSearchModal = false;
        await this.onSearch();
    }

    public async resetAdvancedSearch() {
        this.advancedSearch = this.defaultAdvancedSearch();
        this.advancedSearchTab = 'type';
        await this.onSearch();
    }

    private normalizeDocumentSearchValue(value: any): string {
        if (value === null || value === undefined) return '';
        if (Array.isArray(value)) return value.map((item: any) => this.normalizeDocumentSearchValue(item)).join(' ');
        return String(value).toLowerCase();
    }

    private fieldRelevanceScore(value: any, query: string, weight: number): number {
        const text = this.normalizeDocumentSearchValue(value);
        if (!text || !query) return 0;

        let score = 0;
        if (text === query) score += 120 * weight;
        if (text.startsWith(query)) score += 70 * weight;

        const occurrences = text.split(query).length - 1;
        if (occurrences > 0) score += (25 + Math.min(occurrences, 5) * 5) * weight;

        const tokens = query.split(/\s+/).filter((token: string) => token && token !== query);
        for (const token of tokens) {
            if (text.includes(token)) score += 10 * weight;
        }

        return score;
    }

    public documentRelevanceScore(doc: any): number {
        const apiScore = Number(doc?.relevance_score || 0);
        if (apiScore > 0) return apiScore;

        const query = this.searchText.trim().toLowerCase();
        if (!query) return 0;

        return [
            this.fieldRelevanceScore(doc.hflib_title, query, 10),
            this.fieldRelevanceScore(doc.filename, query, 9),
            this.fieldRelevanceScore(doc.collection_title, query, 7),
            this.fieldRelevanceScore(doc.collection_tags, query, 7),
            this.fieldRelevanceScore(doc.hflib_isbn, query, 6),
            this.fieldRelevanceScore(doc.hflib_author, query, 5),
            this.fieldRelevanceScore(doc.hflib_publication, query, 4),
            this.fieldRelevanceScore(doc.source_board, query, 3),
            this.fieldRelevanceScore(doc.collection_description, query, 3),
            this.fieldRelevanceScore(doc.hflib_volume, query, 2),
            this.fieldRelevanceScore(doc.id, query, 2),
            this.fieldRelevanceScore(doc.collection_id, query, 1),
            this.fieldRelevanceScore(doc.storage_type, query, 1),
            this.fieldRelevanceScore(doc.status, query, 1)
        ].reduce((sum: number, score: number) => sum + score, 0);
    }

    public categoryMatches(col: any, key: string): boolean {
        if (key === 'all') return true;
        const category = this.categoryFilters.find((c: any) => c.key === key);
        if (!category) return false;
        const source = [
            col.title || '',
            col.description || '',
            ...(col.tags || [])
        ].join(' ').toLowerCase();
        return category.keywords.some((keyword: string) => source.includes(keyword.toLowerCase()));
    }

    public categoryFor(col: any): any {
        const matched = this.categoryFilters
            .filter((c: any) => c.key !== 'all')
            .find((c: any) => this.categoryMatches(col, c.key));
        return matched || { key: 'general', label: '일반 연구자료', short: '일반' };
    }

    public categoryLabel(key: string): string {
        const matched = this.categoryFilters.find((c: any) => c.key === key);
        return matched?.label || '전체';
    }

    public catalogNo(col: any): string {
        const raw = (col.id || '').replace(/-/g, '').toUpperCase();
        return `DNAH-COL-${raw.slice(0, 8) || 'NEW'}`;
    }

    public recordType(col: any): string {
        const category = this.categoryFor(col).key;
        if (category === 'publication') return '간행물 묶음';
        if (category === 'archive') return '사료 컬렉션';
        if (category === 'policy') return '정책 대응자료';
        if (category === 'education') return '교육 콘텐츠';
        return '주제 자료군';
    }

    public collectionForDocument(doc: any): any {
        const collection = this.collections.find((col: any) => col.id === doc.collection_id);
        if (collection) return collection;
        return {
            id: doc.collection_id,
            title: doc.collection_title || '',
            description: doc.collection_description || '',
            tags: doc.collection_tags || []
        };
    }

    public documentTitle(doc: any): string {
        const title = doc.hflib_title || doc.filename || '';
        return title.replace(/\.[^/.]+$/, '') || '제목 없는 자료';
    }

    public documentCatalogNo(doc: any): string {
        const raw = (doc.id || '').replace(/-/g, '').toUpperCase();
        return `DNAH-DOC-${raw.slice(0, 8) || 'NEW'}`;
    }

    public documentFormat(doc: any): string {
        const filename = doc.filename || '';
        const ext = filename.includes('.') ? filename.split('.').pop() : '';
        return (ext || 'PDF').toUpperCase();
    }

    public documentStatusLabel(status: string): string {
        if (status === 'completed') return '활용 가능';
        if (status === 'processing') return '원문 분석 중';
        if (status === 'external') return '링크 보관';
        if (status === 'archived') return '원본 보관';
        if (status === 'failed') return '분석 오류';
        if (status === 'cancelled') return '분석 중단';
        return '분석 대기';
    }

    public documentStatusClass(status: string): string {
        if (status === 'completed') return 'text-emerald-700 bg-emerald-50 dark:text-emerald-300 dark:bg-emerald-900/30';
        if (status === 'processing') return 'text-sky-700 bg-sky-50 dark:text-sky-300 dark:bg-sky-900/30';
        if (status === 'external') return 'text-sky-700 bg-sky-50 dark:text-sky-300 dark:bg-sky-900/30';
        if (status === 'archived') return 'text-teal-700 bg-teal-50 dark:text-teal-300 dark:bg-teal-900/30';
        if (status === 'failed') return 'text-red-700 bg-red-50 dark:text-red-300 dark:bg-red-900/30';
        if (status === 'cancelled') return 'text-orange-700 bg-orange-50 dark:text-orange-300 dark:bg-orange-900/30';
        return 'text-amber-700 bg-amber-50 dark:text-amber-300 dark:bg-amber-900/30';
    }

    public documentStorageLabel(doc: any): string {
        return doc?.storage_type === 'local' ? '로컬 원문' : '외부 링크';
    }

    public statusLabel(col: any): string {
        const total = col.doc_count || 0;
        if (total === 0) return '입수 대기';
        if ((col.failed_count || 0) + (col.cancelled_count || 0) > 0) return '확인 필요';
        if ((col.processing_count || 0) > 0) return '원문 분석 중';
        if ((col.analysis_ready_count || 0) > 0) return '분석 대기';
        const pct = this.completionPercent(col);
        if (pct === 100) return '활용 가능';
        if (pct > 0) return '일부 활용 가능';
        return '입수 대기';
    }

    public statusClass(col: any): string {
        const label = this.statusLabel(col);
        if (label === '활용 가능' || label === '일부 활용 가능') return 'text-emerald-700 bg-emerald-50 dark:text-emerald-300 dark:bg-emerald-900/30';
        if (label === '원문 분석 중') return 'text-sky-700 bg-sky-50 dark:text-sky-300 dark:bg-sky-900/30';
        if (label === '분석 대기') return 'text-amber-700 bg-amber-50 dark:text-amber-300 dark:bg-amber-900/30';
        if (label === '확인 필요') return 'text-red-700 bg-red-50 dark:text-red-300 dark:bg-red-900/30';
        return 'text-stone-500 bg-stone-100 dark:text-stone-400 dark:bg-stone-800';
    }

    public defaultNewCollection(): any {
        return {
            title: '',
            description: '',
            collectionType: '재단 간행도서',
            sourceChannel: '동북아역사재단 자료센터',
            registrationPolicy: '서지 먼저 만들고 원문은 별도 입수',
            accessLevel: '내부 열람',
            expectedCount: '',
            updateCycle: '',
            ownerId: '',
            reviewerId: '',
            issueTopics: [],
            periods: [],
            languages: ['한국어'],
            tags: []
        };
    }

    public async openCreateModal() {
        this.showCreateModal = true;
        this.createStep = 0;
        this.newCollection = this.defaultNewCollection();
        this.newTagName = '';
        this.newTagColor = '#6366f1';
        await this.service.render();
    }

    public async nextCreateStep() {
        if (!this.createStepValid()) return;
        this.createStep = Math.min(this.createStep + 1, this.createSteps.length - 1);
        await this.service.render();
    }

    public async prevCreateStep() {
        this.createStep = Math.max(this.createStep - 1, 0);
        await this.service.render();
    }

    public createStepValid(): boolean {
        if (this.createStep === 0) return !!this.newCollection.title.trim();
        if (this.createStep === 1) return !!this.newCollection.sourceChannel;
        if (this.createStep === 3) return !!this.newCollection.accessLevel;
        return true;
    }

    public async applyCollectionTemplate(template: any) {
        this.newCollection.collectionType = template.collectionType || this.newCollection.collectionType;
        this.newCollection.issueTopics = template.issueTopics || [];
        this.newCollection.languages = template.languages || this.newCollection.languages;
        for (const tag of template.tags || []) {
            if (this.newCollection.tags.indexOf(tag) < 0) this.newCollection.tags.push(tag);
        }
        await this.service.render();
    }

    public async closeCreateModal() {
        this.showCreateModal = false;
        await this.service.render();
    }

    public async toggleNewCollectionOption(field: string, value: string) {
        if (!Array.isArray(this.newCollection[field])) this.newCollection[field] = [];
        const selected = this.newCollection[field];
        const idx = selected.indexOf(value);
        if (idx >= 0) {
            selected.splice(idx, 1);
        } else {
            selected.push(value);
        }
        await this.service.render();
    }

    public isNewCollectionOptionSelected(field: string, value: string): boolean {
        return (this.newCollection[field] || []).indexOf(value) >= 0;
    }

    public async toggleNewTag(tag: string) {
        const idx = this.newCollection.tags.indexOf(tag);
        if (idx >= 0) {
            this.newCollection.tags.splice(idx, 1);
        } else {
            this.newCollection.tags.push(tag);
        }
        await this.service.render();
    }

    public async addNewTag() {
        if (!this.newTagName.trim()) return;
        const tag = this.newTagName.trim();
        if (this.newCollection.tags.indexOf(tag) < 0) {
            this.newCollection.tags.push(tag);
        }
        if (!this.allTags.find((t: any) => t.name === tag)) {
            this.allTags.push({ name: tag, color: this.newTagColor });
        }
        this.newTagName = '';
        this.newTagColor = '#6366f1';
        await this.service.render();
    }

    private addUniqueTag(tags: string[], tag: string) {
        const value = String(tag || '').trim();
        if (value && tags.indexOf(value) < 0) tags.push(value);
    }

    private createCollectionTags(): string[] {
        const tags: string[] = [];
        for (const tag of this.newCollection.tags || []) this.addUniqueTag(tags, tag);
        this.addUniqueTag(tags, this.newCollection.collectionType);
        this.addUniqueTag(tags, this.newCollection.sourceChannel);
        for (const tag of this.newCollection.issueTopics || []) this.addUniqueTag(tags, tag);
        for (const tag of this.newCollection.periods || []) this.addUniqueTag(tags, tag);
        for (const tag of this.newCollection.languages || []) this.addUniqueTag(tags, tag);
        return tags;
    }

    private createCollectionDescription(): string {
        const note = String(this.newCollection.description || '').trim();
        const lines: string[] = [];
        if (note) lines.push(note);

        const metadata: string[] = [
            `자료유형: ${this.newCollection.collectionType}`,
            `출처: ${this.newCollection.sourceChannel}`,
            `처리방식: ${this.newCollection.registrationPolicy}`,
            `공개범위: ${this.newCollection.accessLevel}`
        ];
        if (String(this.newCollection.expectedCount || '').trim()) {
            metadata.push(`예상자료수: ${String(this.newCollection.expectedCount).trim()}`);
        }
        if ((this.newCollection.issueTopics || []).length > 0) metadata.push(`역사현안: ${this.newCollection.issueTopics.join(', ')}`);
        if ((this.newCollection.periods || []).length > 0) metadata.push(`시대: ${this.newCollection.periods.join(', ')}`);
        if ((this.newCollection.languages || []).length > 0) metadata.push(`언어: ${this.newCollection.languages.join(', ')}`);

        lines.push(metadata.join(' / '));
        return lines.join('\n');
    }

    private defaultTagColor(tagName: string): string {
        if (this.collectionTypeOptions.indexOf(tagName) >= 0) return '#14b8a6';
        if (this.sourceChannelOptions.indexOf(tagName) >= 0) return '#f97316';
        if (this.issueTopicOptions.indexOf(tagName) >= 0) return '#ef4444';
        if (this.periodOptions.indexOf(tagName) >= 0) return '#8b5cf6';
        if (this.createLanguageOptions.indexOf(tagName) >= 0) return '#3b82f6';
        return '#78716c';
    }

    public async createCollection() {
        if (!this.newCollection.title.trim()) {
            await this.service.alert.show({ title: '알림', message: '자료군 이름을 입력해주세요.' });
            return;
        }

        const tags = this.createCollectionTags();
        const tagColors: any = {};
        for (const tagName of tags) {
            const t = this.allTags.find((x: any) => x.name === tagName);
            tagColors[tagName] = t?.color || this.defaultTagColor(tagName);
        }

        const { code, data } = await wiz.call("create", {
            title: this.newCollection.title.trim(),
            description: String(this.newCollection.description || '').trim(),
            tags: JSON.stringify(tags),
            tag_colors: JSON.stringify(tagColors),
            collection_type: this.newCollection.collectionType,
            source_channel: this.newCollection.sourceChannel,
            registration_policy: this.newCollection.registrationPolicy,
            access_level: this.newCollection.accessLevel,
            expected_count: this.newCollection.expectedCount,
            update_cycle: this.newCollection.updateCycle,
            owner_id: this.newCollection.ownerId,
            reviewer_id: this.newCollection.reviewerId,
            issue_topics: JSON.stringify(this.newCollection.issueTopics || []),
            periods: JSON.stringify(this.newCollection.periods || []),
            languages: JSON.stringify(this.newCollection.languages || [])
        });

        if (code === 200) {
            this.showCreateModal = false;
            if (data?.id) {
                this.service.href(`/collections/${data.id}`);
                return;
            }
            await this.load();
        } else {
            await this.service.modal.show({
                title: '자료군 생성 실패',
                message: data?.message || '자료군을 생성할 수 없습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
        }
    }

    public async deleteTag(tagName: string, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const res = await this.service.modal.show({
            title: '주제어 삭제',
            message: `'${tagName}' 주제어를 삭제하시겠습니까? 자료군에서도 제거됩니다.`,
            action: '삭제',
            actionBtn: 'error'
        });
        if (!res) return;

        const { code } = await wiz.call("delete_tag", { name: tagName });
        if (code === 200) {
            const idx = this.selectedTags.indexOf(tagName);
            if (idx >= 0) this.selectedTags.splice(idx, 1);
            await this.load();
        }
    }

    public infoModal: any = null;

    public async showInfo(col: any, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        this.openMenuId = '';
        this.infoModal = {
            title: col.title,
            collectionId: col.id,
            catalogNo: this.catalogNo(col),
            category: this.categoryFor(col).label,
            type: this.recordType(col),
            status: this.statusLabel(col),
            milvusName: `dnah_${col.id.replace(/-/g, '_')}`
        };
        await this.service.render();
    }

    public async closeInfoModal() {
        this.infoModal = null;
        await this.service.render();
    }

    public async copyToClipboard(text: string) {
        try {
            await navigator.clipboard.writeText(text);
        } catch (e) { }
    }

    public async deleteCollection(id: string, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const res = await this.service.modal.show({
            title: '자료군 삭제',
            message: '이 자료군을 삭제하시겠습니까? 포함된 원문 자료도 함께 삭제됩니다.',
            action: '삭제',
            actionBtn: 'error'
        });
        if (!res) return;

        const { code } = await wiz.call("delete", { id });
        if (code === 200) {
            await this.load();
        }
    }
}

export default PageCollectionsComponent;